<div class="row rcx-dashboard" *ngIf="context.persona === 'ADMIN'">
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{companyCard.name}}</p>
            <h4 *ngIf="!c1Loading" class="my-1">{{companyCard.count}}
            </h4>
            <div *ngIf="c1Loading" role="status" class="spinner-border text-success"></div>
            <p class="mb-0 font-13 text-success"><i class="bx bxs-up-arrow align-middle"></i> {{companyCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-success text-success ms-auto"><i class="bx bxs-building-house"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{activeUserCard.name}}</p>
            <h4 *ngIf="!c2Loading" class="my-1">{{activeUserCard.count}}</h4>
            <div *ngIf="c2Loading" role="status" class="spinner-border text-warning"></div>
            <p class="mb-0 font-13 text-danger"><i class='bx bxs-down-arrow align-middle'></i> {{activeUserCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-warning text-warning ms-auto"><i class='bx bxs-group'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{licenseCard.name}}</p>
            <h4 *ngIf="!c3Loading" class="my-1">{{licenseCard.count??0}}</h4>
            <div *ngIf="c3Loading" role="status" class="spinner-border text-info"></div>
            <p class="mb-0 font-13 text-success"><i class='bx bxs-up-arrow align-middle'></i>{{licenseCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-info text-info ms-auto"><i class='bx bxs-group'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{userCard.name}}</p>
            <h4 *ngIf="!c4Loading" class="my-1">{{userCard.count}}</h4>
            <div *ngIf="c4Loading" role="status" class="spinner-border text-danger"></div>
            <p class="mb-0 font-13 text-success"><i class='bx bxs-up-arrow align-middle'></i> {{userCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-danger text-danger ms-auto"><i class='bx bxs-group'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card radius-5">
      <div class="card-body">
        <apx-chart [series]="adminBarGraph.series" [chart]="adminBarGraph.chart" [xaxis]="adminBarGraph.xaxis"
          [dataLabels]="adminBarGraph.dataLabels" [grid]="adminBarGraph.grid" [stroke]="adminBarGraph.stroke"
          [title]="adminBarGraph.title" [labels]="adminBarGraph.labels" [yaxis]="adminBarGraph.yaxis"
          [annotations]="adminBarGraph.annotations"></apx-chart>
        <div class="col-lg-auto year-filter">
          <div class="input-group">
            <span class="input-group-text bg-primary" id="filter" ngbTooltip="Select a year to filter the metrics."
              placement="top" container="body">
              <i class="bx bx-calendar"></i>
            </span>
            <select id="filter" class="form-select border-start-0" [(ngModel)]="selectedYear"
              (change)="getMetrisOnChange()">
              <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- HR DASHBORD -->
<div class="row rcx-dashboard" *ngIf="context.persona === 'HR'">
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{employeeHrCard.name}}</p>
            <h4 *ngIf="!c1Loading" class="my-1">{{employeeHrCard.count}}
            </h4>
            <div *ngIf="c1Loading" role="status" class="spinner-border text-success"></div>
            <p class="mb-0 font-13 text-success"><i class="bx bxs-up-arrow align-middle"></i>{{employeeHrCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-success text-success ms-auto"><i class="bx bxs-group"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{totalAttendance.name}}</p>
            <h4 *ngIf="!c2Loading" class="my-1">{{totalAttendance.count}}</h4>
            <div *ngIf="c2Loading" role="status" class="spinner-border text-warning"></div>
            <p class="mb-0 font-13 text-warning"><i class='bx bxs-down-arrow align-middle'></i>{{totalAttendance.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-warning text-warning ms-auto"><i class='bx bxs-calendar-check'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{overduePayments.name}}</p>
            <h4 *ngIf="!c3Loading" class="my-1">{{overduePayments.count}}</h4>
            <div *ngIf="c3Loading" role="status" class="spinner-border text-info"></div>
            <p class="mb-0 font-13 text-info"><i class='bx bxs-up-arrow align-middle'></i>{{overduePayments.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-info text-info ms-auto"><i class='bx bx-credit-card'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{completedPayments.name}}</p>
            <h4 *ngIf="!c4Loading" class="my-1">{{completedPayments.count}}</h4>
            <div *ngIf="c4Loading" role="status" class="spinner-border text-danger"></div>
            <p class="mb-0 font-13 text-danger"><i class='bx bxs-up-arrow align-middle'></i>{{completedPayments.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-danger text-danger ms-auto"><i class='bx bx-credit-card'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card radius-5">
      <div class="card-body">
        <apx-chart [series]="hrBarGraph.series" [chart]="hrBarGraph.chart" [xaxis]="hrBarGraph.xaxis"
          [dataLabels]="hrBarGraph.dataLabels" [grid]="hrBarGraph.grid" [stroke]="hrBarGraph.stroke"
          [title]="hrBarGraph.title" [labels]="hrBarGraph.labels" [yaxis]="hrBarGraph.yaxis"
          [annotations]="hrBarGraph.annotations">
        </apx-chart>

        <div class="col-lg-auto year-filter">
          <div class="input-group">
            <span class="input-group-text bg-primary" id="filter" ngbTooltip="Select a year to filter the metrics."
              placement="top" container="body">
              <i class="bx bx-calendar"></i>
            </span>
            <select id="filter" class="form-select border-start-0" [(ngModel)]="selectedYear"
              (change)="getHrMetrisOnChange()">
              <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end row-->
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2 card-sec" *ngIf="context.persona==='HR'">
    <!-- Holidays Card -->
    <div class="col">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Holidays</h5>
              <!-- <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days revenue</p> -->
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let holiday of holidayCardDetails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img src="assets/images/icons/holiday.png" alt="" />
                </div>
                <div class="ms-2">
                  <h6 class="mb-1 font-14 capitalize-first"><strong>{{holiday.name}}</strong></h6>
                  <p class="mb-0">{{holiday.date | date:'MMM dd, yyyy'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Birthdays Card -->
    <div class="col">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Birthdays</h5>
              <!-- <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days revenue</p> -->
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let birthday of birthdayCardDtails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img src="assets/images/icons/cake.png" alt="" />
                </div>
                <div class="ms-2">
                  <h6 class="mb-1 font-14 capitalize-first"><strong>{{birthday.name}}</strong></h6>
                  <p class="mb-0">{{birthday.date | date:'MMM dd'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- New Joinees Card -->
    <div class="col">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">New Joinees</h5>
              <!-- <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days revenue</p> -->
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let newJoinee of joineeCardDetails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img src="assets/images/icons/new Joining.png" alt="" />
                </div>
                <div class="ms-2">
                  <h6 class="mb-1 font-14 capitalize-first"><strong>{{newJoinee.name}}</strong></h6>
                  <p class="mb-0">{{newJoinee.date | date:'MMM dd, yyyy'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row rcx-dashboard dashboad" *ngIf="context.persona === 'HR'">
    <div class="col-lg-4">
      <div class="card radius-5">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <p class="mb-0">{{totalLeaves.name}}</p>
              <h4 *ngIf="!c1Loading" class="my-1">{{totalLeaves.count}}
              </h4>
              <div *ngIf="c1Loading" role="status" class="spinner-border text-success"></div>
              <p class="mb-0 font-13 text-success"><i class="bx bxs-up-arrow align-middle"></i> {{totalLeaves.greetings}}</p>
            </div>
            <div class="widgets-icons bg-light-success text-success ms-auto"><i class="bx bxs-calendar-x"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="card radius-5">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <p class="mb-0">{{totalRegularizations.name}}</p>
              <h4 *ngIf="!c1Loading" class="my-1">{{totalRegularizations.count}}
              </h4>
              <div *ngIf="c1Loading" role="status" class="spinner-border text-warning"></div>
              <p class="mb-0 font-13 text-warning"><i class="bx bxs-up-arrow align-middle"></i>{{totalRegularizations.greetings}}</p>
            </div>
            <div class="widgets-icons bg-light-success text-warning ms-auto"><i class="bx bxs-calendar-check"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="card radius-5">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <p class="mb-0">{{totalAbsences.name}}</p>
              <h4 *ngIf="!c1Loading" class="my-1">{{totalAbsences.count}}
              </h4>
              <div *ngIf="c1Loading" role="status" class="spinner-border text-danger"></div>
              <p class="mb-0 font-13 text-danger"><i class="bx bxs-up-arrow align-middle"></i>{{totalAbsences.greetings}}</p>
            </div>
            <div class="widgets-icons bg-light-success text-danger ms-auto"><i class="bx bxs-user-x"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end row-->
  <div class="col-lg-12">
    <div class="card radius-5">
      <div class="card-body">
        <apx-chart [series]="hrEmployeeBarGraph.series" [chart]="hrEmployeeBarGraph.chart"
          [xaxis]="hrEmployeeBarGraph.xaxis" [dataLabels]="hrEmployeeBarGraph.dataLabels"
          [grid]="hrEmployeeBarGraph.grid" [stroke]="hrEmployeeBarGraph.stroke" [title]="hrEmployeeBarGraph.title"
          [labels]="hrEmployeeBarGraph.labels" [yaxis]="hrEmployeeBarGraph.yaxis"
          [annotations]="hrEmployeeBarGraph.annotations">
        </apx-chart>

        <div class="col-lg-auto year-filter">
          <div class="input-group">
            <span class="input-group-text bg-primary" id="filter" ngbTooltip="Select a year to filter the metrics."
              placement="top" container="body">
              <i class="bx bx-calendar"></i>
            </span>
            <select id="filter" class="form-select border-start-0" [(ngModel)]="selectedYear"
              (change)="getHrMetrisOnChange()">
              <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- CLIENT DASHBORD -->
<div class="row rcx-dashboard" *ngIf="context.persona === 'CLIENT'">
  <div class="col-lg-4">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">Total Users</p>
            <h4 *ngIf="!c4Loading" class="my-1">{{userCard.count}}</h4>
            <div *ngIf="c4Loading" role="status" class="spinner-border text-danger"></div>
            <p class="mb-0 font-13 text-success"><i class='bx bxs-up-arrow align-middle'></i>{{userCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-danger text-danger ms-auto"><i class='bx bxs-group'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{activeUserCard.name}}</p>
            <h4 *ngIf="!c2Loading" class="my-1">{{activeUserCard.count}}</h4>
            <div *ngIf="c2Loading" role="status" class="spinner-border text-warning"></div>
            <p class="mb-0 font-13 text-success"><i class='bx bxs-up-arrow align-middle'></i> {{activeUserCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-warning text-warning ms-auto"><i class='bx bxs-group'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">Total Employees</p>
            <h4 *ngIf="!c3Loading" class="my-1">{{employeeCard.count??0}}</h4>
            <div *ngIf="c3Loading" role="status" class="spinner-border text-info"></div>
            <p class="mb-0 font-13 text-success"><i class='bx bxs-up-arrow align-middle'></i>{{employeeCard.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-info text-info ms-auto"><i class='bx bxs-group'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card radius-5">
      <div class="card-body">
        <apx-chart [series]="adminBarGraph.series" [chart]="adminBarGraph.chart" [xaxis]="adminBarGraph.xaxis"
          [dataLabels]="adminBarGraph.dataLabels" [grid]="adminBarGraph.grid" [stroke]="adminBarGraph.stroke"
          [title]="adminBarGraph.title" [labels]="adminBarGraph.labels" [yaxis]="adminBarGraph.yaxis"
          [annotations]="adminBarGraph.annotations"></apx-chart>
        <div class="col-lg-auto year-filter">
          <div class="input-group">
            <span class="input-group-text bg-primary" id="filter" ngbTooltip="Select a year to filter the metrics."
              placement="top" container="body">
              <i class="bx bx-calendar"></i>
            </span>
            <select id="filter" class="form-select border-start-0" [(ngModel)]="selectedYear"
              (change)="getMetrisOnChange()">
              <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- EMPLOYEE DASHBORD -->
<div class="row rcx-dashboard" *ngIf="context.persona === 'EMPLOYEE'">
  <div class="col-lg-4">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{totalLeaves.name}}</p>
            <h4 *ngIf="!c1Loading" class="my-1">{{totalLeaves.count}}
            </h4>
            <div *ngIf="c1Loading" role="status" class="spinner-border text-success"></div>
            <p class="mb-0 font-13 text-success"><i class="bx bxs-up-arrow align-middle"></i> {{totalLeaves.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-success text-success ms-auto"><i class="bx bxs-calendar-x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{totalRegularizations.name}}</p>
            <h4 *ngIf="!c1Loading" class="my-1">{{totalRegularizations.count}}
            </h4>
            <div *ngIf="c1Loading" role="status" class="spinner-border text-warning"></div>
            <p class="mb-0 font-13 text-warning"><i class="bx bxs-up-arrow align-middle"></i>{{totalRegularizations.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-success text-warning ms-auto"><i class="bx bxs-calendar-check"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">{{totalAbsences.name}}</p>
            <h4 *ngIf="!c1Loading" class="my-1">{{totalAbsences.count}}
            </h4>
            <div *ngIf="c1Loading" role="status" class="spinner-border text-danger"></div>
            <p class="mb-0 font-13 text-danger"><i class="bx bxs-up-arrow align-middle"></i>{{totalAbsences.greetings}}</p>
          </div>
          <div class="widgets-icons bg-light-success text-danger ms-auto"><i class="bx bxs-user-x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end row-->
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2  card-sec">
    <!-- Holidays Card -->
    <div class="col">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Holidays</h5>
              <!-- <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days revenue</p> -->
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let holiday of holidayCardDetails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img src="assets/images/icons/holiday.png" alt="" />
                </div>
                <div class="ms-2">
                  <h6 class="mb-1 font-14 capitalize-first"><strong>{{holiday.name}}</strong></h6>
                  <p class="mb-0">{{holiday.date | date:'MMM dd, yyyy'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Birthdays Card -->
    <div class="col">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Birthdays</h5>
              <!-- <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days revenue</p> -->
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let birthday of birthdayCardDtails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img src="assets/images/icons/cake.png" alt="" />
                </div>
                <div class="ms-2">
                  <h6 class="mb-1 font-14 capitalize-first"><strong>{{birthday.name}}</strong></h6>
                  <p class="mb-0">{{birthday.date | date:'MMM dd'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- New Joinees Card -->
    <div class="col">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">New Joinees</h5>
              <!-- <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days revenue</p> -->
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let newJoinee of joineeCardDetails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img src="assets/images/icons/new Joining.png" alt="" />
                </div>
                <div class="ms-2">
                  <h6 class="mb-1 font-14 capitalize-first"><strong>{{newJoinee.name}}</strong></h6>
                  <p class="mb-0">{{newJoinee.date | date:'MMM dd, yyyy'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--end row-->
  <div class="col-lg-12">
    <div class="card radius-5">
      <div class="card-body">
        <apx-chart [series]="employeeBarGraph.series" [chart]="employeeBarGraph.chart" [xaxis]="employeeBarGraph.xaxis"
          [dataLabels]="employeeBarGraph.dataLabels" [grid]="employeeBarGraph.grid" [stroke]="employeeBarGraph.stroke"
          [title]="employeeBarGraph.title" [labels]="employeeBarGraph.labels" [yaxis]="employeeBarGraph.yaxis"
          [annotations]="employeeBarGraph.annotations">
        </apx-chart>

        <div class="col-lg-auto year-filter">
          <div class="input-group">
            <span class="input-group-text bg-primary" id="filter" ngbTooltip="Select a year to filter the metrics."
              placement="top" container="body">
              <i class="bx bx-calendar"></i>
            </span>
            <select id="filter" class="form-select border-start-0" [(ngModel)]="selectedYear"
              (change)="getEmployeeMetrisOnChange()">
              <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ACCOUNTANT DASHBORD -->
<div class="row rcx-dashboard" *ngIf="context.persona === 'ACCOUNTANT'">
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">Total Employees</p>
            <h4 *ngIf="!c3Loading" class="my-1">{{employeeCard.count??0}}</h4>
            <div *ngIf="c3Loading" role="status" class="spinner-border text-info"></div>
            <p class="mb-0 font-13 text-success"><i class='bx bxs-up-arrow align-middle'></i> 1 new hire this month</p>
          </div>
          <div class="widgets-icons bg-light-info text-info ms-auto"><i class='bx bxs-group'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">Total Payroll</p>
            <h4 *ngIf="!c1Loading" class="my-1">₹3,20,200</h4>
            <div *ngIf="c1Loading" role="status" class="spinner-border text-danger"></div>
            <p class="mb-0 font-13 text-success"><i class='bx bxs-up-arrow align-middle'></i> for the current month</p>
          </div>
          <div class="widgets-icons bg-light-danger text-danger ms-auto"><i class='bx bxs-wallet'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">Overdue Payments</p>
            <h4 *ngIf="!c2Loading" class="my-1">₹1,20,200</h4>
            <div *ngIf="c2Loading" role="status" class="spinner-border text-warning"></div>
            <p class="mb-0 font-13 text-danger"><i class='bx bxs-up-arrow align-middle'></i> for the last month</p>
          </div>
          <div class="widgets-icons bg-light-warning text-warning ms-auto"><i class='bx bxs-wallet-alt'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="card radius-5">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-0">Employee Attendance</p>
            <h4 *ngIf="!c4Loading" class="my-1">{{employeeCard.count??0}}</h4>
            <div *ngIf="c4Loading" role="status" class="spinner-border text-primary"></div>
            <p class="mb-0 font-13 text-danger"><i class='bx bxs-up-arrow align-middle'></i> 2 employees are not present
            </p>
          </div>
          <div class="widgets-icons bg-light-primary text-primary ms-auto"><i class='bx bxs-book'></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
















<!-- hr dashboad -->
<!-- <ng-container *ngIf="context.persona=='EMPLOYEE'">
  <div class="row row-cols-1 row-cols-xl-2">
    <div class="col d-flex">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">New Joinees</h5>
              <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days</p>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let join of joineeCardDetails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img alt="" [src]="join?.image ? 'data:image/jpg;base64,' + join?.image :'/assets/images/avatar.png'">
                </div>
                <div class="ms-2">
                  <h6 class="mb-1">{{join.name}}</h6>
                  <p class="mb-0">{{join.date|date}}</p>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <h6 class="mb-1">{{join.count}}</h6>
              <p class="mb-0">{{join.greetings}}</p>
            </div>


          </div>


        </div>
      </div>
    </div>
    <div class="col d-flex">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Upcoming Birthdays</h5>
              <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days</p>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>
        <div class="product-list p-3 mb-3" [perfectScrollbar]>
          <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer" *ngFor="let birthday of birthdayCardDtails">
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <div class="product-img">
                  <img alt=""
                    [src]="birthday?.image ? 'data:image/jpg;base64,' + birthday?.image :'/assets/images/icons/cake.png'">
                </div>
                <div class="ms-2">
                  <h6 class="mb-1">{{birthday.name}}</h6>
                  <p class="mb-0">{{birthday.date|date}}</p>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <h6 class="mb-1">{{birthday.count}}</h6>
              <p class="mb-0">{{birthday.greetings}}</p>
            </div>


          </div>


        </div>
      </div>
    </div>
  </div>
</ng-container> -->
<!--end row-->
<!-- <ng-container *ngIf="context.persona=='EMPLOYEE'">
  <div class="row row-cols-1 row-cols-xl-2">
    <div class="col-6">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Holiday</h5>
              <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days


              </p>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>


          <div class="customers-list p-3 mb-3" [perfectScrollbar]>






            <div class="customers-list-item d-flex align-items-center border-bottom p-2 cursor-pointer"
              *ngFor="let holiday of holidayCardDetails">
              <div class="">
                <img [src]="holiday?.image ? 'data:image/jpg;base64,' + holiday?.image :'/assets/images/avatar.png'"
                  class="rounded-circle" width="46" height="46" alt="" />
              </div>
              <div class="ms-2">
                <h6 class="mb-1 font-14">{{holiday.name}}</h6>
                <p class="mb-0 font-13 text-secondary">{{holiday.date|date}}</p>
              </div>
              <div class="list-inline d-flex customers-contacts ms-auto"> <a href="#" (click)="$event.preventDefault()"
                  class="list-inline-item"><i class='bx bxs-envelope'></i></a>
                <a href="#" (click)="$event.preventDefault()" class="list-inline-item"><i
                    class='bx bxs-microphone'></i></a>
                <a href="#" (click)="$event.preventDefault()" class="list-inline-item"><i
                    class='bx bx-dots-vertical-rounded'></i></a>
              </div>
            </div>








          </div>






          <div style="text-align:center">
                        <apx-chart [series]="employeeGraph.series" [chart]="employeeGraph.chart"
                            [xaxis]="employeeGraph.xaxis" [title]="employeeGraph.title"></apx-chart>
                    </div>
        </div>
      </div>
    </div>


    <div class="col d-flex" *ngIf="context.persona !== 'EMPLOYEE'">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Leave</h5>
              <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days


              </p>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>


          <div style="text-align:center">
            <apx-chart [series]="leaveGraph.series" [chart]="leaveGraph.chart" [xaxis]="leaveGraph.xaxis"
              [title]="leaveGraph.title"></apx-chart>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div class="row row-cols-1 row-cols-xl-2" *ngIf="context.persona !== 'EMPLOYEE'">
    <div class="col d-flex">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Regularization</h5>
              <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days


              </p>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>


          <div style="text-align:center">
            <apx-chart [series]="regularGraph.series" [chart]="regularGraph.chart" [xaxis]="regularGraph.xaxis"
              [title]="regularGraph.title"></apx-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="col d-flex" *ngIf="context.persona !== 'EMPLOYEE'">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Absence</h5>
              <p class="mb-0 font-13 text-secondary"><i class='bx bxs-calendar'></i>in last 30 days


              </p>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
        </div>


        <div class="row border mx-0 mb-3 py-2 radius-5 cursor-pointer">
          <div id="chart">
            <apx-chart [series]="absenceGraph.series" [chart]="absenceGraph.chart" [xaxis]="absenceGraph.xaxis"
              [dataLabels]="absenceGraph.dataLabels" [grid]="absenceGraph.grid" [stroke]="absenceGraph.stroke"
              [title]="absenceGraph.title"></apx-chart>
          </div>
        </div>


      </div>
    </div>


  </div>
</ng-container> -->


<!--end row-->
<!-- <ng-container *ngIf="context.persona==='HR'">
    <div class="d-flex ">
        <div class="col-md-2 col-lg-2 mb-2">
            <select class="form-select" autocomplete="off" id="employee-gender"
                (change)="getEmployeeDashboard($event.target.value)">
                <option hidden value="" disabled selected>Select Employee</option>
                <option *ngFor="let emp of emmployees" [ngValue]="emp.id">{{emp.name}}</option>
            </select>
        </div>
    </div>
</ng-container> -->
<!-- <ng-container>
  <div class="row row-cols-1 row-cols-lg-3">
    <div class="col d-flex">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-0">Leave</h5>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
          <div class="mt-5" id="chart15">


          </div>
        </div>
        <div id="chart">
          <apx-chart [series]="employeeLeave.series" [chart]="employeeLeave.chart" [xaxis]="employeeLeave.xaxis"
            [dataLabels]="employeeLeave.dataLabels" [grid]="employeeLeave.grid" [stroke]="employeeLeave.stroke"
            [title]="employeeLeave.title"></apx-chart>
        </div>


      </div>
    </div>
    <div class="col d-flex">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-0">Regular</h5>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
          <div class="mt-5" id="chart15"></div>
        </div>
        <div id="chart">
          <apx-chart [series]="employeeRegular.series" [chart]="employeeRegular.chart" [xaxis]="employeeRegular.xaxis"
            [dataLabels]="employeeRegular.dataLabels" [grid]="employeeRegular.grid" [stroke]="employeeRegular.stroke"
            [title]="employeeRegular.title"></apx-chart>
        </div>


      </div>
    </div>
    <div class="col d-flex">
      <div class="card radius-5 w-100">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-0">Absence</h5>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
          <div class="mt-5" id="chart15"></div>
        </div>
        <div id="chart">
          <apx-chart [series]="employeeAbsence.series" [chart]="employeeAbsence.chart" [xaxis]="employeeAbsence.xaxis"
            [dataLabels]="employeeAbsence.dataLabels" [grid]="employeeAbsence.grid" [stroke]="employeeAbsence.stroke"
            [title]="employeeAbsence.title"></apx-chart>
        </div>


      </div>
    </div>
  </div>
</ng-container> -->




<!-- <div class="d-flex ">
            <div class="col-md-2 col-lg-2 mb-2">
                <select class="form-select" autocomplete="off" id="employee-gender"
                    (change)="getCompanyEmployeeGraph($event.target.value)">
                    <option hidden value="" disabled selected>Select Company</option>
                    <option *ngFor="let comp of companies" [ngValue]="comp.id">{{comp.name}}</option>
                </select>
            </div>
        </div> -->
<!--
    <div class="col-6">
      <div class="card radius-5">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div>
              <h5 class="mb-1">Total Users</h5>
            </div>
            <div class="font-22 ms-auto"><i class='bx bx-dots-horizontal-rounded'></i>
            </div>
          </div>
          <div id="chart">
            <apx-chart [series]="userGraph.series" [chart]="userGraph.chart" [xaxis]="userGraph.xaxis"
              [dataLabels]="userGraph.dataLabels" [grid]="userGraph.grid" [stroke]="userGraph.stroke"
              [title]="userGraph.title"></apx-chart>
          </div>
        </div>
      </div>
    </div> -->